import React from 'react';
import { ReactComponent as ScanIcon } from "assets/img/svg/scanner.svg"
import styles from "./styles.module.scss";

const ScanChequeCta = () => {
    return ( 
        <div className='cursor'>
            <span className={`mr-2 ${styles['scan-cheque-cta']}`}>Scan Cheque</span>
            <ScanIcon/>
        </div>
     );
}
 
export default ScanChequeCta;